import React from 'react';
import {
  AvatarMedium,
  AvatarSmall,
  ListingCard,
  NamedLink,
  ReviewRating,
} from '../../../components';
import Slider from 'react-slick';
import classNames from 'classnames';

import css from './Sections.module.css';
import '../../../styles/slick/slick.css';
import '../../../styles/slick/slick-theme.css';
import { ensureUser } from '../../../util/data';
import Icons from '../../../components/Icons/Icons';

function SectionTestimonials(props) {
  const { sliderSettings, listings, intl, viewport, currentUser } = props;

  const title = intl.formatMessage({ id: 'SectionTestimonial.title' });

  const isMobileLayout = viewport && viewport.width > 0 && viewport.width < 768;

  return (
    <div className={css.sectionTestimonial}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          <div className={css.leftSec}>
            <h2>Recent client reviews</h2>
          </div>
        </div>
        <div className={css.featuredListingsContent}>
          <Slider {...sliderSettings}>
            <div className={css.testimonialBlock}>
              <div className={css.testimonialDescription}>
                <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque fuga dolores,
                  accusantium tempora dolorem eos odio, rem aperiam similique ea quibusdam minus
                  nesciunt, nobis qui tempore. Harum quis nobis numquam.
                </p>
                <div className={css.rating}>
                  <span>Maia</span> <span>1 day ago</span>
                  <ReviewRating className={css.stars} />
                </div>
              </div>
              <div className={css.userInfo}>
                <div className={css.userLeft}>
                  <AvatarMedium user={currentUser} className={css.providerAvatar} />
                  <div className={css.authorDetails}>
                    <h3>John Smith</h3>
                    <p>Personal trainer, FitLife Gym</p>
                  </div>
                </div>
              </div>
            </div>
            <div className={css.testimonialBlock}>
              <div className={css.testimonialDescription}>
                <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque fuga dolores,
                  accusantium tempora dolorem eos odio, rem aperiam similique ea quibusdam minus
                  nesciunt, nobis qui tempore. Harum quis nobis numquam.
                </p>
                <div className={css.rating}>
                  <span>Maia</span> <span>1 day ago</span>
                  <ReviewRating className={css.stars} />
                </div>
              </div>
              <div className={css.userInfo}>
                <div className={css.userLeft}>
                  <AvatarMedium user={currentUser} className={css.providerAvatar} />
                  <div className={css.authorDetails}>
                    <h3>John Smith</h3>
                    <p>Personal trainer, FitLife Gym</p>
                  </div>
                </div>
              </div>
            </div>
            <div className={css.testimonialBlock}>
              <div className={css.testimonialDescription}>
                <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque fuga dolores,
                  accusantium tempora dolorem eos odio, rem aperiam similique ea quibusdam minus
                  nesciunt, nobis qui tempore. Harum quis nobis numquam.
                </p>
                <div className={css.rating}>
                  <span>Maia</span> <span>1 day ago</span>
                  <ReviewRating className={css.stars} />
                </div>
              </div>
              <div className={css.userInfo}>
                <div className={css.userLeft}>
                  <AvatarMedium user={currentUser} className={css.providerAvatar} />
                  <div className={css.authorDetails}>
                    <h3>John Smith</h3>
                    <p>Personal trainer, FitLife Gym</p>
                  </div>
                </div>
              </div>
            </div>
            <div className={css.testimonialBlock}>
              <div className={css.testimonialDescription}>
                <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque fuga dolores,
                  accusantium tempora dolorem eos odio, rem aperiam similique ea quibusdam minus
                  nesciunt, nobis qui tempore. Harum quis nobis numquam.
                </p>
                <div className={css.rating}>
                  <span>Maia</span> <span>1 day ago</span>
                  <ReviewRating className={css.stars} />
                </div>
              </div>
              <div className={css.userInfo}>
                <div className={css.userLeft}>
                  <AvatarMedium user={currentUser} className={css.providerAvatar} />
                  <div className={css.authorDetails}>
                    <h3>John Smith</h3>
                    <p>Personal trainer, FitLife Gym</p>
                  </div>
                </div>
              </div>
            </div>
            <div className={css.testimonialBlock}>
              <div className={css.testimonialDescription}>
                <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque fuga dolores,
                  accusantium tempora dolorem eos odio, rem aperiam similique ea quibusdam minus
                  nesciunt, nobis qui tempore. Harum quis nobis numquam.
                </p>
                <div className={css.rating}>
                  <span>Maia</span> <span>1 day ago</span>
                  <ReviewRating className={css.stars} />
                </div>
              </div>
              <div className={css.userInfo}>
                <div className={css.userLeft}>
                  <AvatarMedium user={currentUser} className={css.providerAvatar} />
                  <div className={css.authorDetails}>
                    <h3>John Smith</h3>
                    <p>Personal trainer, FitLife Gym</p>
                  </div>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </div>
  );
}

const sliderSettings = {
  dots: false,
  arrows: false,
  infinite: false,
  autoplaySpeed: 3000,
  autoplay: false,
  speed: 500,
  slidesToShow: 3, // Display 4 items on desktop
  slidesToScroll: 1, // Scroll 1 item at a time
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 676,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};
SectionTestimonials.defaultProps = {
  sliderSettings,
};

export default SectionTestimonials;
